export enum DictationSurface {
  chat = 'chat',
  matterOverview = 'matter_overview',
}

export enum DictationFailure {
  permissionOrDevice = 'permission_or_device',
  transcription = 'transcription',
}
